import { ArrowUpRight, Mail, Phone, MonitorSmartphone, CalendarCheck } from "lucide-react";
import SectionHeader from "@/components/site/SectionHeader";

const BOOKING_URL =
  "https://outlook.office.com/bookwithme/user/b7225bf50f9b4b979c1b0aea80d80018@dvag.de?anonymous&ismsaljsauthenabled&ep=plink";

export default function Contact({ hideIntro = false }) {
  return (
    <section
      id="kontakt"
      data-testid="contact-section"
      className="relative py-24 md:py-32 bg-bone-100 overflow-hidden"
    >
      <div aria-hidden className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-sage-100 blur-3xl opacity-70" />
      <div aria-hidden className="absolute -top-20 -right-20 w-[360px] h-[360px] rounded-full bg-clay-100 blur-3xl opacity-70" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        {!hideIntro && (
          <SectionHeader
            chapter="07"
            label="Kontakt"
            title="Lass uns gemeinsam"
            italic="schauen."
            accent="sage"
            intro="In einem ersten Gespräch schauen wir gemeinsam, was dich gerade beschäftigt. Unverbindlich und kostenfrei — du entscheidest in Ruhe, was als Nächstes kommt."
          />
        )}

        <div className="grid sm:grid-cols-3 gap-5">
          <a
            href="mailto:beratung@xeniahoefel.de"
            data-testid="contact-card-email"
            className="group flex items-start gap-5 p-6 rounded-[1.25rem] bg-sage-100 hover:bg-sage-300/40 transition-colors"
          >
            <div className="w-12 h-12 rounded-full bg-sage-500 text-bone-50 flex items-center justify-center shrink-0">
              <Mail strokeWidth={1.75} className="w-4 h-4" />
            </div>
            <div className="flex-1">
              <div className="font-mono-fine text-[10px] tracking-[0.22em] uppercase text-sage-700">E-Mail</div>
              <div className="mt-1 font-display text-lg text-ink-900 break-all">beratung@xeniahoefel.de</div>
            </div>
            <ArrowUpRight strokeWidth={1.5} className="w-4 h-4 text-sage-700 mt-4 shrink-0 transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
          </a>

          <a
            href="tel:+4915156166703"
            data-testid="contact-card-phone"
            className="group flex items-start gap-5 p-6 rounded-[1.25rem] bg-clay-100 hover:bg-clay-300/40 transition-colors"
          >
            <div className="w-12 h-12 rounded-full bg-clay-500 text-bone-50 flex items-center justify-center shrink-0">
              <Phone strokeWidth={1.75} className="w-4 h-4" />
            </div>
            <div className="flex-1">
              <div className="font-mono-fine text-[10px] tracking-[0.22em] uppercase text-clay-600">Telefon</div>
              <div className="mt-1 font-display text-lg text-ink-900">+49 151 56166703</div>
            </div>
            <ArrowUpRight strokeWidth={1.5} className="w-4 h-4 text-clay-600 mt-4 shrink-0 transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
          </a>

          <div data-testid="contact-card-availability" className="flex items-start gap-5 p-6 rounded-[1.25rem] bg-honey-100">
            <div className="w-12 h-12 rounded-full bg-honey-500 text-ink-900 flex items-center justify-center shrink-0">
              <MonitorSmartphone strokeWidth={1.75} className="w-4 h-4" />
            </div>
            <div className="flex-1">
              <div className="font-mono-fine text-[10px] tracking-[0.22em] uppercase text-honey-600">Beratung</div>
              <div className="mt-1 font-display text-lg text-ink-900 leading-snug">Online &amp; persönlich</div>
              <div className="mt-1 text-[13px] text-ink-700">Je nachdem, was für dich gerade besser passt.</div>
            </div>
          </div>
        </div>

        <div className="mt-8 relative overflow-hidden rounded-[2rem] p-8 md:p-12 bg-ink-900 text-bone-50 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div aria-hidden className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-sage-500/20 blur-3xl" />
          <div className="relative max-w-md">
            <span className="font-mono-fine text-[10px] tracking-[0.22em] uppercase text-honey-300">
              Direkter Weg zu mir
            </span>
            <h3 className="mt-3 font-display text-2xl md:text-3xl leading-snug">
              Vereinbare direkt einen kostenfreien Kennenlern-Termin.
            </h3>
            <p className="mt-3 text-bone-200 text-[15px] leading-relaxed">
              Wähle einfach einen passenden Slot in meinem Online-Kalender — unverbindlich und ohne Umwege per E-Mail.
            </p>
          </div>
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="contact-booking-cta"
            className="relative group shrink-0 inline-flex items-center gap-3 pl-7 pr-2 h-14 rounded-full bg-sage-500 hover:bg-sage-600 text-bone-50 text-[14px] tracking-wide transition-all duration-300 hover:-translate-y-0.5"
          >
            <CalendarCheck strokeWidth={1.75} className="w-4 h-4" />
            Termin vereinbaren
            <span className="w-11 h-11 rounded-full bg-honey-400 text-ink-900 flex items-center justify-center transition-transform duration-500 group-hover:rotate-45">
              <ArrowUpRight strokeWidth={1.75} className="w-4 h-4" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
